import { useEffect } from 'react';

export const useScrollRestore = (history, watchPaths = []) => {
  useEffect(() => {
    const currentPath = history.location.pathname;
    const locationState = history.location.state || {};

    if (watchPaths.includes(currentPath) && locationState.fromVehicleDetail) {
      const savedScrollY = sessionStorage.getItem(`scrollY:${currentPath}`);
      if (savedScrollY) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScrollY, 10));

          // Clean up the state after scroll restoration
          history.replace(currentPath, {});
        }, 50); // Delay ensures render is complete
      }
    }

    const unlisten = history.listen((location) => {
      const fromPath = currentPath;
      const toPath = location.pathname;

      const isGoingToDetailPage =
        (toPath.startsWith('/vehicles/') && toPath !== '/vehicles') ||
        (toPath.startsWith('/used-vehicles/') && toPath !== '/used-vehicles');

      if (isGoingToDetailPage && watchPaths.includes(fromPath)) {
        sessionStorage.setItem(
          `scrollY:${fromPath}`,
          window.scrollY.toString()
        );
      }
    });

    return () => unlisten();
  }, [history, watchPaths]);
};
